import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { BF2GetConfigBasedOutskirtBuilding } from "./BF2GetConfigBasedOutskirtBuilding";
export var BF2GetOutskirtBuildingHarbor = function (data, level, buildingState, isAccessible, buildingName) {
    var config = artConfigBuildings["Harbor1"];
    return BF2GetConfigBasedOutskirtBuilding(config, false, 1);
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetOutskirtBuildingHarbor.ts
// module id = 2163
// module chunks = 3